<script>
  import { onMount } from 'svelte';
  import { Tabs, Tab, TabList, TabPanel } from 'svelte-tabs';
  import { TextField, Button } from "smelte";
  import { format } from "date-fns";
  import { nl } from 'date-fns/locale';
  import { exportTitle, exportSigner, exportType, exportDate, storedEditorContent } from "store";
  import ToolkitEditor from 'components/editor/ToolkitEditor.svelte';
  import Exporter from 'components/exporter/Exporter.svelte';
  import SignatureCanvas from 'components/SignatureCanvas.svelte';
  
  let reportTitle = "";
  let reportSigner= "";
  let editorContent = "";
  
  $: reportTitle = $exportTitle;
  $: reportSigner = $exportSigner;

  onMount(() => {
    // initialize with existing content
    if (!$exportType) {
      exportType.set("conceptreport");
    };
    reportTitle = $exportTitle;
    reportSigner = $exportSigner;
    exportDate.set(format(new Date(), 'eeee dd MMMM yyyy', {locale: nl}));
	});
  
  function updateFields(e) {
    exportTitle.set(reportTitle);
    exportSigner.set(reportSigner);
  };

  if ($storedEditorContent !== null) {
    // if content has been pushed to use in conceptReportgeneration
    editorContent = $storedEditorContent;
  };

  function resetContent() {
    // <Button text on:click={resetContent}>Leegmaken</Button>
    editorContent = '';
  };

</script>
<main>
  
  <div class="mx-2">  
    <h1 class="text-xl font-bold">
      Concept-PV
    </h1>

    <Tabs>
      <TabList>
        <Tab>Algemeen</Tab>
        <Tab>Verklaring</Tab>
        <Tab>Onderteken</Tab>
      </TabList>
     
      <TabPanel>
        <TextField bind:value={reportTitle} on:change={updateFields} label="Titel van het proces-verbaal" hint="Bijv. Aangifte inbraak [adres] of Verhoor verdachte/getuige [naam]" persistentHint color="blue" />
        <TextField bind:value={reportSigner} on:change={updateFields} label="Naam betrokkene of ondertekenaar" hint="Naam van persoon die in concept tekent; bijvoorbeeld: V. ERDACHTE" persistentHint color="blue" />
      </TabPanel>

      <TabPanel>
        <ToolkitEditor {editorContent} />
      </TabPanel>
     
      <TabPanel>
        <SignatureCanvas />
        <Exporter />
      </TabPanel>
    </Tabs>

  </div>
</main>

<style>
  
</style>